import React, { Component,useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import Header1 from '../Layout/Header1';
import Breadcrumb from '../Layout/Breadcrumb';
import FullWidth from '../Layout/FullWidth';
import PageWithSideBar from '../Layout/PageWithSideBar';
import Sidebar from '../Layout/Sidebar';
import Footer from '../Layout/Footer';
import getBaseUrl from '../../base/htttp';
import init from '../../js/main';
import PageNotFound from '../Errors/PageNotFound'

function PublicationDetails() {    
	const [data, setData] = useState("Loading...");
	const [statusCode, setStatusCode] = useState();
    const pageSlug = useParams();
	const getData = () => {
		fetch(getBaseUrl()+"publication/"+pageSlug.slug)        
		.then(async (response) => {
			if (response.ok) {
			  return response.json()
			} else if(response.status === 404) {
				setStatusCode(response.status)
				return "";
			} else {
			  console.log('some other error: ' + response.status)
			}
		})
		.then(async (result) => {
			if(result!="" && result.success){
				setData(result.data);
				setTimeout(function() {
					init();
				}.bind(this), 400);												
			}
		})
	}

	useEffect(() => {
		getData();
	}, []);

	if (statusCode === 404) {
		return <PageNotFound />
	}
	return (        
		<div>			
            <Header1 />
			<div className='main'>
				<Breadcrumb data={data} image={data.title_background}/>
				<section className='project-detail'>
                    <div className='container'>
					    <FullWidth content={data.content} />
                    </div>
				</section>
				<Footer />
			</div>
		</div>
	);
}

export default PublicationDetails;